var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{ref:"modal",attrs:{"width":300,"modal-error":_vm.modalError},on:{"hide":function($event){return _vm.$emit('hide')}}},[_vm._t("default",function(){return [_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }